<ng-template #template>
  <ng-container *ngIf="isDisplayed">
    <div class="l-mybooking__option-item">
      <asw-next-action-item
        (clickNextAction)="onClick()"
        [canBeClicked]="canBeClicked"
        [title]="'label.registerEvidenceHandicapped' | staticMsg"
        [titleAria]="'reader.certificate RegistrationDiscountsDisabled' | staticMsg"
        itemId="register-evidence-disabled"
      >
      </asw-next-action-item>
    </div>
  </ng-container>
</ng-template>
